<template>
  <div>
    <v-dialog v-if="userData" v-model="show" max-width="406" flat elevation="0" persistent>
      <v-card v-if="loading" class="rounded-lg py-16 ma-0">
        <v-card-title>
          <loading-progress :status="loading" />
        </v-card-title>
      </v-card>
      <v-card v-else color="greyColorLigthTwo" class="rounded-lg pa-0 ma-0">
        <v-img
          height="250"
          :src="require('@/../public/images/Thanks.png').default"
        ></v-img>
        <v-card-title class="mt-5">
          <div class="text-center" style="width: 100%">
            <v-avatar size="75">
              <img :src="userData.Avatar" :alt="userData.FullName" />
            </v-avatar>
          </div>
        </v-card-title>
        <v-card-title class="mb-5">
          <div
            class="defaultColor--text font-weight-regular text-center px-2"
            style="font-size: 15px; line-height: 25px; width: 100%"
          >
            {{ $t("description.thanked", { name: userData.FullName }) }}
          </div>
        </v-card-title>

        <v-card-actions class="justify-center align-center pb-5">
          <v-btn
            color="greenColor"
            class="white--text text-capitalize rounded-pill"
            block
            height="67"
            elevation="0"
            rounded
            large
            @click="gotoProfile()"
          >
            {{ "Profile Git" }}
          </v-btn>
        </v-card-actions>
      </v-card>

      <dialog-close-button @clickButton="closeModal" />
    </v-dialog>
  </div>
</template>

<script>
import DialogCloseButton from "../General/DialogCloseButton.vue";
import LoadingProgress from "../General/LoadingProgress.vue";
import UserService from "../../services/UserService";

export default {
  data() {
    return {
      loading: false,
      userData: null,
    };
  },
  props: {
    visible: Boolean,
  },
  mounted() {},
  components: {
    DialogCloseButton,
    LoadingProgress,
  },
  methods: {
    startPage() {
      if (this.$store.state.thanksDetailUserId) {
        this.loading = true;
        UserService.getUserInfo(this.$store.state.thanksDetailUserId)
          .then((res) => {
            console.log("user about :", res.data);
            this.userData = res.data;
          })
          .catch((err) => {
            console.log(err);
            showError(err);
          })
          .then(() => {
            this.loading = false;
          });
      } else {
        showInfo(this.$t("description.unexpected"), "standart", "error");
        //this.closeModal()
      }
    },

    gotoProfile() {
      gotoProfile(this.userData.Id);
      this.closeModal();
    },

    closeModal() {
      this.$store.state.thanksDetailDialogStatus = false;
      this.$store.state.thanksDetailUserId = null;
      this.loading = false;
      this.userdata = null;
      this.show = false;
    },
  },
  computed: {
    show: {
      get() {
        if (this.visible) {
          this.startPage();
        }
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  watch: {},
};
</script>
